var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInputFlagRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.7663 5.0715L5.09961 2.62067V1.94775C5.09961 1.65734 4.85878 1.4165 4.56836 1.4165C4.27794 1.4165 4.03711 1.65734 4.03711 1.94775V15.0519C4.03711 15.3423 4.27794 15.5832 4.56836 15.5832C4.85878 15.5832 5.09961 15.3423 5.09961 15.0519V12.2469L10.9221 9.37109C10.9221 9.37109 10.9221 9.37109 10.9292 9.37109C12.105 8.76192 12.7354 7.97567 12.7 7.14692C12.6646 6.31817 11.9775 5.5815 10.7663 5.0715Z",
    fill: "#D30000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputFlagRed);
export default __webpack_public_path__ + "static/media/input-flag-red.4f8343c78dd125e2a5e01361e1a0eeb8.svg";
export { ForwardRef as ReactComponent };